import { CardSvg } from '@/play/cardSvg'

/** Home card art: two slimes with googly eyes under a candy light, a pink rim on each. */
export function SlimeFamilyCardArt() {
  return (
    <CardSvg bg="#ffd9ec">
      <rect y="140" width="320" height="60" fill="#f6e6ff" />
      {/* the lime one */}
      <path d="M60 168 C 58 116, 92 92, 124 92 C 156 92, 190 116, 188 168 C 186 176, 62 176, 60 168 Z" fill="#7ee35b" stroke="#ff5fb8" strokeWidth="3" />
      <path d="M48 170 C 46 156, 62 150, 72 158 L 70 172 Z" fill="#7ee35b" />
      <circle cx="104" cy="122" r="15" fill="#fbfbf6" />
      <circle cx="146" cy="120" r="17" fill="#fbfbf6" />
      <circle cx="107" cy="127" r="8" fill="#15131c" />
      <circle cx="149" cy="126" r="9" fill="#15131c" />
      <ellipse cx="84" cy="114" rx="5" ry="10" fill="#ffffff" opacity="0.55" transform="rotate(30 84 114)" />
      {/* the pink one */}
      <path d="M204 170 C 202 134, 226 118, 248 118 C 270 118, 294 134, 292 170 C 290 176, 206 176, 204 170 Z" fill="#ff5fa2" stroke="#ff8fcf" strokeWidth="3" />
      <circle cx="236" cy="142" r="11" fill="#fbfbf6" />
      <circle cx="264" cy="142" r="11" fill="#fbfbf6" />
      <circle cx="234" cy="147" r="6" fill="#15131c" />
      <circle cx="262" cy="147" r="6" fill="#15131c" />
      {/* a purple baby */}
      <path d="M176 186 C 176 168, 186 160, 196 160 C 206 160, 216 168, 216 186 Z" fill="#a66bff" />
      <circle cx="196" cy="172" r="7" fill="#fbfbf6" />
      <circle cx="196" cy="175" r="3.6" fill="#15131c" />
    </CardSvg>
  )
}
